import * as React from "react";
import { AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

type Props = {
  title?: string;
  description?: string;
  className?: string;
};

export const NotConfiguredBanner: React.FC<Props> = ({
  title = "Henüz yapılandırılmadı",
  description = "Bu bölüm, Supabase bağlantısı ve ilgili onaylar tamamlandığında etkinleşecek. Bu aşamada yalnızca arayüz iskeleti gösterilmektedir — hiçbir gerçek veri okunmuyor veya yazılmıyor.",
  className,
}) => {
  return (
    <div
      role="status"
      data-testid="not-configured-banner"
      className={cn(
        "flex items-start gap-3 rounded-lg border border-accent/30 bg-accent/5 px-4 py-3.5",
        className,
      )}
    >
      <div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent/15">
        <AlertTriangle className="h-4 w-4 text-accent" strokeWidth={2} />
      </div>
      <div className="space-y-1">
        <p className="text-sm font-semibold text-foreground">{title}</p>
        <p className="text-sm leading-relaxed text-muted-foreground">
          {description}
        </p>
      </div>
    </div>
  );
};
